export enum UnitTypeEnum {
  all = 0,
  grammars = 1,
  grades = 2,
}
